import { render, staticRenderFns } from "./BlocoDataAcaoMonitoramentoAgricola.vue?vue&type=template&id=4fe2ac35&scoped=true&lang=pug"
import script from "./BlocoDataAcaoMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./BlocoDataAcaoMonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./BlocoDataAcaoMonitoramentoAgricola.vue?vue&type=style&index=0&id=4fe2ac35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe2ac35",
  null
  
)

export default component.exports